import React from "react";
import { Outlet } from "react-router-dom";
import { Box, CssBaseline, Toolbar, Drawer, AppBar } from "@mui/material";
import NavigationBar from "./NavigationBar";
import SidebarNavigation from "./SidebarNavigation";

const drawerWidth = 240;

const WithSidebarAndNavigationBar: React.FC = () => {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <NavigationBar />
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
      >
        <Toolbar />
        <SidebarNavigation />
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          // Plain white per the system standard for the My Biz pages; fill
          // the full height below the AppBar so the background never stops
          // at the viewport edge on long pages.
          bgcolor: "#ffffff",
          minHeight: "calc(100vh - 64px)",
          p: 3,
          mt: "64px", // Height of the AppBar
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default WithSidebarAndNavigationBar;
